import { render, staticRenderFns } from "./LiquidationSubmissionList.vue?vue&type=template&id=7889be42&scoped=true&lang=pug"
import script from "./LiquidationSubmissionList.vue?vue&type=script&lang=js"
export * from "./LiquidationSubmissionList.vue?vue&type=script&lang=js"
import style0 from "./LiquidationSubmissionList.vue?vue&type=style&index=0&id=7889be42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889be42",
  null
  
)

export default component.exports